import pino, { LoggerOptions } from 'pino';
import { isClient } from '../common/utils';

let clientSideLogger: pino.Logger;
let serversideLogger: pino.Logger;

const pinoConfig: LoggerOptions = {
  timestamp: () => `,"@timestamp":"${new Date().toISOString()}"`,
  messageKey: 'message',
  level: process.env.NODE_ENV === 'development' ? 'trace' : 'info',
  browser: { asObject: false },
  transport:
    process.env.NODE_ENV !== 'development'
      ? undefined
      : {
          target: 'pino-pretty',
          options: {
            colorize: true,
            translateTime: 'SYS:HH:MM:ss.l',
            messageKey: 'message',
            ignore: '@version,tags',
            timestampKey: '@timestamp',
          },
        },
  formatters: {
    bindings: ({ pid, hostname }) => ({
      pid,
      hostname,
      container_id: process.env.HOSTNAME,
      '@version': 1,
      tags: process.env.LOG_TAG ? [process.env.LOG_TAG] : [],
    }),
    level: label => ({ level: label }),
  },
};

const loggerModule = {
  get logger(): pino.Logger {
    if (process.env.NODE_ENV === 'test') {
      return console as unknown as pino.Logger;
    } else if (isClient()) {
      if (!clientSideLogger) {
        clientSideLogger = pino(pinoConfig);
      }
      return clientSideLogger;
    } else {
      if (!serversideLogger) {
        serversideLogger = pino(pinoConfig);
      }
      return serversideLogger;
    }
  },
};

export const logger = loggerModule.logger;
